export default __webpack_public_path__ + "static/media/include_14_male@3x.53913a4a.jpg";